export default __webpack_public_path__ + "static/media/flow.173e9622.svg";